const SESSION_KEY = 'sales-qa:usage-session-id';
const encoder = new TextEncoder();

type UsageEventName =
  | 'pipeline_opened'
  | 'pipeline_filter_changed'
  | 'pipeline_deal_opened'
  | 'pipeline_deal_deeplink_clicked'
  | 'pipeline_contact_opened'
  | 'pipeline_export_or_copy_clicked'
  | 'ron_card_opened';

function getSessionId(): string {
  const existing = window.sessionStorage.getItem(SESSION_KEY);
  if (existing) return existing;
  const id = crypto.randomUUID();
  window.sessionStorage.setItem(SESSION_KEY, id);
  return id;
}

async function sha256Hex(input: string): Promise<string> {
  const digest = await crypto.subtle.digest('SHA-256', encoder.encode(input));
  return Array.from(new Uint8Array(digest), (b) => b.toString(16).padStart(2, '0')).join('');
}

export async function trackUsageEvent(
  event_name: UsageEventName,
  opts: {
    route?: string;
    entity_type?: string;
    entity_id?: string | number | null;
    metadata?: Record<string, unknown>;
  } = {},
): Promise<void> {
  try {
    const payload = {
      route: opts.route ?? window.location.pathname,
      event_name,
      session_id_hash: await sha256Hex(getSessionId()),
      entity_type: opts.entity_type,
      entity_id: opts.entity_id == null ? undefined : String(opts.entity_id),
      metadata: opts.metadata,
    };
    const body = JSON.stringify(payload);
    const blob = new Blob([body], { type: 'application/json' });
    if (navigator.sendBeacon('/api/usage-events', blob)) return;
    await fetch('/api/usage-events', {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body,
      keepalive: true,
    });
  } catch {
    // Telemetry must never affect the operator workflow.
  }
}
